export const ROOT = 'polls-viewer';
export const INSERT_POLL_BUTTON = 'insert-poll-button';
export const INSERT_POLL_MODAL = 'insert-poll-modal';

export const INSERT_POLL_MODAL_THUMBNAIL_PICKER = 'insert-poll-modal-thumbnail-picker';
export const INSERT_POLL_MODAL_THUMBNAIL = 'insert-poll-modal-thumbnail-';

// Both editor and viewer
export const POLLS_MULTIPLE_ANSWER_TEXT = 'polls-multiple-answer-text';
export const POLLS_QUESTION_IMAGE = 'polls-question-image';
export const POLLS_ANSWER_IMAGE = 'polls-answer-image';
export const POLLS_ANSWER_ITEMS = 'polls-answer-items';
export const POLLS_QUESTION_TEXT_INPUT = 'polls-question-text-input';
export const POLLS_ANSWER_TEXT_INPUT = 'polls-answer-text-input';
export const POLLS_VOTED_USER_ITEM = 'polls-voted-user-item';

// Edit Mode
export const POLLS_ADD_ANSWER_BUTTON = 'polls-add-answer-item-button';
export const POLLS_REMOVE_ANSWER_BUTTON = 'polls-remove-answer-item-button';

// Preview Mode
export const POLLS_ITEM_PERCENTAGE_PREVIEW = 'polls-items-percentage-preview';

export const PLUGIN_TOOLBAR_DESIGN_BUTTON = 'plugin-toolbar-design-button';
export const PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON = 'plugin-toolbar-layout-dropdown-button';
export const LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT = 'layout-dropdown-option-customize-layout';
export const LAYOUT_DROPDOWN_OPTION_GRID = 'layout-dropdown-option-grid';
export const LAYOUT_DROPDOWN_OPTION_LIST = 'layout-dropdown-option-list';

export const SETTINGS_MODAL = 'poll-settings-modal';
export const SETTINGS_TABS = 'settings-tabs';
export const SETTINGS_LAYOUT_TAB = 'settings-layout-tab';
export const SETTINGS_DESIGN_TAB = 'settings-design-tab';
export const SETTINGS_GENERAL_TAB = 'settings-general-tab';
export const GENERAL_SETTINGS_MULTIPLE_ANSWERS_TOGGLE = 'general-settings-multiple-answers-toggle';
export const GENERAL_SETTINGS_VOTE_COUNT_TOGGLE = 'general-settings-vote-count-toggle';
export const GENERAL_SETTINGS_EACH_PERSON_VOTE_TOGGLE = 'general-settings-each-person-vote-toggle';
export const GENERAL_SETTINGS_VIEW_PERMISSIONS_RADIO_GROUP =
  'general-settings-view-permissions-radio-group';
export const GENERAL_SETTINGS_VOTE_PERMISSIONS_RADIO_GROUP =
  'general-settings-vote-permissions-radio-group';
export const LAYOUT_SETTINGS_IMAGE_TO_QUESTION_TOGGLE = 'layout-settings-image-to-question-toggle';
export const LAYOUT_SETTINGS_IMAGE_TO_ANSWERS_TOGGLE = 'layout-settings-image-to-answers-toggle';

export const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER = 'layout-settings-layout-thumbnail-picker';
export const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL = 'layout-settings-layout-thumbnail-';

export const LAYOUT_SETTINGS_DIRECTION_TOGGLE = 'layout-settings-direction-toggle';

export const DESIGN_SETTINGS_BACKGROUND_THUMBNAIL_PICKER =
  'design-settings-background-thumbnail-picker';
export const DESIGN_SETTINGS_BACKGROUND_THUMBNAIL = 'design-settings-background-thumbnail-';
export const DESIGN_SETTINGS_BACKGROUND_GRADIENT_BUTTON =
  'design-settings-background-gradient-button';
export const DESIGN_SETTINGS_BACKGROUND_COLOR_BUTTON = 'design-settings-background-color-button';
export const DESIGN_SETTINGS_BACKGROUND_IMAGE_BUTTON = 'design-settings-background-image-button';

export const DESIGN_SETTINGS_CORNER_RADIUS_SLIDER = 'design-settings-border-radius-slider';
export const DESIGN_SETTINGS_CORNER_RADIUS_INPUT = 'design-settings-border-radius-input';
export const DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_SLIDER =
  'design-settings-answers-corner-radius-slider';
export const DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_INPUT =
  'design-settings-answers-corner-radius-input';
